import { TagColor } from "@bridgesplit/ui";

import { TimeLockStatus, TimeLockUpdateType } from "../types";

export const DEFAULT_LP_SLIPPAGE = 0.001;

// Temporary incident patch: the USDC Genesis vault's on-chain share value is inflated, so the app
// shows a hardcoded value instead and blocks the vault from Explore and its detail URL.
export const USDC_GENESIS_VAULT_ADDRESS = "AXanCP4dJHtWd7zY4X7nwxN5t5Gysfy2uG3XTxSmXdaB";
// oneUSDC, the vault's LP token. Its oracle reads the vault directly, so collateral is inflated too.
export const USDC_GENESIS_LP_MINT = "Hj3avy8d4k1skU3aScok7VWxEQSw6Bchuu5C9oV6vNz5";
export const USDC_GENESIS_PRINCIPAL_MINT = "EPjFWdd5AufqSSqeM2qN1xzybapC8G4wEGGkZwyTDt1v";
// USDC per LP share: the last good value from vault history, 2026-11-05 06:06 UTC.
// If set to undefined the vault shows no value rather than the inflated one.
export const USDC_GENESIS_TRUE_LP_PRICE: number | undefined = 1.114422;
// No real vault backs this much loan collateral; anything above it is stamped off the inflated price.
export const MAX_SANE_VAULT_LOAN_COLLATERAL_USD = 10_000_000_000;

export const TIMELOCK_UPDATE_UI: Record<TimeLockUpdateType, string> = {
    [TimeLockUpdateType.UpdateStrategyMarketInformation]: "Update Strategy Market Information",
    [TimeLockUpdateType.AddCollateral]: "Add Collateral",
    [TimeLockUpdateType.UpdateLtv]: "Update LTV",
    [TimeLockUpdateType.RemoveCollateral]: "Remove Collateral",
    [TimeLockUpdateType.UpdateApy]: "Update APY",
    [TimeLockUpdateType.UpdateStrategySettings]: "Update Strategy Settings",
    [TimeLockUpdateType.UpdateVaultSettings]: "Update Vault Settings",
    [TimeLockUpdateType.CapsUpdate]: "Caps Update",
    [TimeLockUpdateType.UpdateCollateralAllocationPct]: "Update Collateral Allocation Percent"
};

export const TIMELOCK_STATUS_UI: Record<TimeLockStatus, string> = {
    [TimeLockStatus.Pending]: "Pending",
    [TimeLockStatus.Executed]: "Executed",
    [TimeLockStatus.Cancelled]: "Cancelled"
};

export const TIMELOCK_STATUS_COLOR: Record<TimeLockStatus, TagColor> = {
    [TimeLockStatus.Pending]: "warning",
    [TimeLockStatus.Executed]: "success",
    [TimeLockStatus.Cancelled]: "error"
};
